///////// Lib. /////////
////////////////////////

// ...

/////// Utils.. ////////
////////////////////////

// ...

///// Event hdls. //////
////////////////////////

// ...

//////// Assets ////////
////////////////////////

const logArgs = { eventName: "init_submit", inline: true, disabled: false };
const msgs = {
  start: ["init. submit"],
  end: ["init. submit", "init. success"],
  no_el: ["init. submit", "no valid DOM el. provided"],
};

///// Init. method def. //////
//////////////////////////////

export default function init_submit() {
  //////// Setup /////////
  ////////////////////////

  const { btn_submit } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);
  if (!this.validate_refEl(btn_submit)) return this.cancel_featInit(msgs.no_el);

  //////// ACTION ////////
  ////////////////////////

  btn_submit.addEventListener("click", this.api.submit);

  /////// Conclude ///////
  ////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}
